export interface Coordinate {
  x: number;
  y: number;
  z?: number;
}

export interface Feature {
  Coordinate?: Coordinate;
  Points?: Coordinate[];
  ExteriorRing?: { Points: Coordinate[] };
}

export interface Point {
  identifier: string;
  Feature: Feature;
}

export interface Line {
  identifier: string;
  Feature: { Points: Coordinate[] };
}

export interface Polygon {
  identifier: string;
  Feature: { ExteriorRing: { Points: Coordinate[] } };
}

export interface Geometry {
  Points?: Point[];
  Lines?: Line[];
  Polygons?: Polygon[];
}

export enum GeometryEditType {
  Point = 0,
  Line = 1,
  Polygon = 2,
}
